// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./Buttons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./Typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Poppins';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    background-color: #eeeeee;
    color: #0B1547 !important;
    margin: 0px;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace, 'Poppins';
}

.container {
    display: flex;
    text-align: center;
    padding: 20px;
    background-color: #fff;
}

.container h1 {
    color: #333;
}

.container p {
    color: #666;
}

.global-content {
    padding: 120px 40px;
}

.react-player-rounded video {
    border-radius: 32px;
}

/* @media screen and (min-width: 769px) {

    .global-content {
        padding-left: 160px;
        padding-right: 160px;
    }

} */

.ant-select-selector {
    border-radius: 100px !important;
    border: none !important
}

h2 {
    margin: 0;
}

.full-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
}

@media screen and (max-width: 1024px) {

    .global-content {
        padding-left: 16px;
        padding-right: 16px;
    }
    h2 {
        padding-bottom: 32px;
    }

    .full-container {
        display: block;
    }

    .react-player-rounded video {
        border-radius: 16px;
    }
}

.fade-in {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
}

.fade-out {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
}

.ant-collapse-item {
    font-family: 'Poppins';
}

.grecaptcha-badge {
    visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/css/Globals.css"],"names":[],"mappings":"AAIA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI;4BACwB;AAC5B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;;;GAOG;;AAEH;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iEAAiE;AACrE;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('./Buttons.css');\n@import url('./Typography.css');\n\nbody {\n    font-family: 'Poppins';\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: flex;\n    flex-direction: column;\n    background-color: #eeeeee;\n    color: #0B1547 !important;\n    margin: 0px;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n        monospace, 'Poppins';\n}\n\n.container {\n    display: flex;\n    text-align: center;\n    padding: 20px;\n    background-color: #fff;\n}\n\n.container h1 {\n    color: #333;\n}\n\n.container p {\n    color: #666;\n}\n\n.global-content {\n    padding: 120px 40px;\n}\n\n.react-player-rounded video {\n    border-radius: 32px;\n}\n\n/* @media screen and (min-width: 769px) {\n\n    .global-content {\n        padding-left: 160px;\n        padding-right: 160px;\n    }\n\n} */\n\n.ant-select-selector {\n    border-radius: 100px !important;\n    border: none !important\n}\n\nh2 {\n    margin: 0;\n}\n\n.full-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n\n    .global-content {\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n    h2 {\n        padding-bottom: 32px;\n    }\n\n    .full-container {\n        display: block;\n    }\n\n    .react-player-rounded video {\n        border-radius: 16px;\n    }\n}\n\n.fade-in {\n    opacity: 1;\n    visibility: visible;\n    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;\n}\n\n.fade-out {\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;\n}\n\n.ant-collapse-item {\n    font-family: 'Poppins';\n}\n\n.grecaptcha-badge {\n    visibility: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
